module.exports = __webpack_public_path__ + "static/media/fly0010.40877e3f.webp";